import apiService from '../utils/apiService';

import {
  ADD_DECISION,
  ADD_DECISION_START,
  ADD_DECISION_ERROR,
  UPDATE_DECISION,
  UPDATE_DECISION_START,
  UPDATE_DECISION_ERROR,
  GET_DECISION,
  GET_DECISION_START,
  GET_DECISION_ERROR,
  GET_DECISION_LIST,
  GET_DECISION_LIST_START,
  GET_DECISION_LIST_ERROR,
  DELETE_DECISION,
  DELETE_DECISION_START,
  DELETE_DECISION_ERROR,
  CLEAR_ERROR_DECISION,
  GET_DECISION_LIST_PAGEABLE,
  CHANGE_DECISION_STATUS,
  CHANGE_DECISION_STATUS_START,
  CHANGE_DECISION_STATUS_ERROR,
  GET_DECISION_BY_REQUEST,
  GET_DECISION_BY_REQUEST_ERROR,
  GET_DECISION_BY_REQUEST_START,
  CHANGE_STATUS_DECISION,
  CHANGE_STATUS_DECISION_START,
  CHANGE_STATUS_DECISION_ERROR,
  GET_DECISION_FILTER_LIST,
  GET_DECISION_FILTER_LIST_START,
  GET_DECISION_FILTER_LIST_ERROR,
  SEND_DECISION,
  SEND_DECISION_START,
  SEND_DECISION_ERROR,
} from './types';

import {
  decisionAddPath,
  decisionUpdatePath,
  decisionFindAllPath,
  decisionFindByIdPath,
  decisionDeletePath,
  decisionFindAllPageablePath,
  changeDecisionStatusPath,
  decisionAddWithAttachmentPath,
  decisionFindByRequestIdPath,
  changeDecisionStatusWithStatusPath,
  filterPageablePath,
  sendDecisionToRobonPath,
} from '../constants/apiEndpoints';

import {
  findDecisionAttachmentByDecision,
  removeAttachment,
} from './decisionAttachment';
import { createNotification } from '../utils';
import {
  decisionStatuses,
  notificationTypeError,
  notificationTypeSuccess,
} from '../constants/globals';

const clearError = () => {
  return {
    type: CLEAR_ERROR_DECISION,
  };
};

const addDecisionStart = () => {
  return {
    type: ADD_DECISION_START,
  };
};
const addDecisionSuccessfully = (data) => {
  return {
    type: ADD_DECISION,
    payload: data,
  };
};
const addDecisionUnsuccessfully = (err) => {
  return {
    type: ADD_DECISION_ERROR,
    payload: err,
  };
};

const updateDecisionStart = () => {
  return {
    type: UPDATE_DECISION_START,
  };
};
const updateDecisionSuccessfully = (data) => {
  return {
    type: UPDATE_DECISION,
    payload: data,
  };
};
const updateDecisionUnsuccessfully = (err) => {
  return {
    type: UPDATE_DECISION_ERROR,
    payload: err,
  };
};

const getDecisionStart = () => {
  return {
    type: GET_DECISION_START,
  };
};
const getDecisionSuccessfully = (data) => {
  return {
    type: GET_DECISION,
    payload: data,
  };
};
const getDecisionUnsuccessfully = (err) => {
  return {
    type: GET_DECISION_ERROR,
    payload: err,
  };
};

const getDecisionByRequestIdStart = () => {
  return {
    type: GET_DECISION_BY_REQUEST_START,
  };
};
const getDecisionByRequestIdSuccessfully = (data) => {
  return {
    type: GET_DECISION_BY_REQUEST,
    payload: data,
  };
};
const getDecisionByRequestIdUnsuccessfully = (err) => {
  return {
    type: GET_DECISION_BY_REQUEST_ERROR,
    payload: err,
  };
};

const getDecisionListStart = () => {
  return {
    type: GET_DECISION_LIST_START,
  };
};
const getDecisionListSuccessfully = (data) => {
  return {
    type: GET_DECISION_LIST,
    payload: data,
  };
};

const getDecisionPageableListSuccessfully = (
  data,
  pageNumber,
  totalElements
) => {
  return {
    type: GET_DECISION_LIST_PAGEABLE,
    payload: [data, pageNumber, totalElements],
  };
};
const getDecisionListUnsuccessfully = (err) => {
  return {
    type: GET_DECISION_LIST_ERROR,
    payload: err,
  };
};

const deleteDecisionStart = () => {
  return {
    type: DELETE_DECISION_START,
  };
};
const deleteDecisionSuccessfully = (id) => {
  return {
    type: DELETE_DECISION,
    payload: id,
  };
};
const deleteDecisionUnsuccessfully = (err) => {
  return {
    type: DELETE_DECISION_ERROR,
    payload: err,
  };
};

const changeDecisionStatusWithStatusStart = () => {
  return {
    type: CHANGE_STATUS_DECISION_START,
  };
};
const changeDecisionStatusWithStatusSuccessfully = (data) => {
  return {
    type: CHANGE_STATUS_DECISION,
    payload: data,
  };
};
const changeDecisionStatusWithStatusUnsuccessfully = (err) => {
  return {
    type: CHANGE_STATUS_DECISION_ERROR,
    payload: err,
  };
};

const changeDecisionStatusStart = () => {
  return {
    type: CHANGE_DECISION_STATUS_START,
  };
};
const changeDecisionStatusSuccessfully = (data) => {
  return {
    type: CHANGE_DECISION_STATUS,
    payload: data,
  };
};
const changeDecisionStatusUnsuccessfully = (err) => {
  return {
    type: CHANGE_DECISION_STATUS_ERROR,
    payload: err,
  };
};

const getDecisionFilterListStart = () => {
  return {
    type: GET_DECISION_FILTER_LIST_START,
  };
};
const getDecisionFilterListSuccessfully = (data, pageNumber, totalElements) => {
  return {
    type: GET_DECISION_FILTER_LIST,
    payload: [data, pageNumber, totalElements],
  };
};
const getDecisionFilterListUnsuccessfully = (err) => {
  return {
    type: GET_DECISION_FILTER_LIST_ERROR,
    payload: err,
  };
};

const sendDecisionStart = () => {
  return {
    type: SEND_DECISION_START,
  };
};
const sendDecisionSuccessfully = (data) => {
  return {
    type: SEND_DECISION,
    payload: data,
  };
};
const sendDecisionUnsuccessfully = (err) => {
  return {
    type: SEND_DECISION_ERROR,
    payload: err,
  };
};

export const createDecision = (decision, callback, messages, callback2) => {
  return (dispatch) => {
    dispatch(addDecisionStart());
    return apiService
      .post(decisionAddPath(), decision)
      .then((response) => {
        dispatch(addDecisionSuccessfully(response.data));
        callback();
      })
      .catch((err) => {
        dispatch(addDecisionUnsuccessfully(err?.response?.data));
      });
  };
};

export const updateDecision = (decision, callback) => {
  return (dispatch) => {
    dispatch(updateDecisionStart());
    return apiService
      .post(decisionUpdatePath(), decision)
      .then((response) => {
        dispatch(updateDecisionSuccessfully(response.data));
        callback();
      })
      .catch((err) => {
        dispatch(updateDecisionUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllDecisions = () => {
  return (dispatch) => {
    dispatch(getDecisionListStart());
    return apiService
      .get(decisionFindAllPath())
      .then((response) => {
        dispatch(getDecisionListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getDecisionListUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllDecisionsPageble = (pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(getDecisionListStart());
    return apiService
      .get(decisionFindAllPageablePath(pageNumber, pageSize))
      .then((response) => {
        dispatch(
          getDecisionPageableListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(getDecisionListUnsuccessfully(err?.response?.data));
      });
  };
};

export const findDecisionById = (id) => {
  return (dispatch) => {
    dispatch(getDecisionStart());
    return apiService
      .get(decisionFindByIdPath(id))
      .then((response) => {
        dispatch(getDecisionSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getDecisionUnsuccessfully(err?.response?.data));
      });
  };
};

export const findDecisionByRequestId = (id) => {
  return (dispatch) => {
    dispatch(getDecisionByRequestIdStart());
    return apiService
      .get(decisionFindByRequestIdPath(id))
      .then((response) => {
        dispatch(getDecisionByRequestIdSuccessfully(response.data));
        if (response.data.id)
          dispatch(findDecisionAttachmentByDecision(response.data.id));
        else {
          dispatch(removeAttachment());
        }
      })
      .catch((err) => {
        dispatch(getDecisionByRequestIdUnsuccessfully(err?.response?.data));
      });
  };
};

export const deleteDecision = (id) => {
  return (dispatch) => {
    dispatch(deleteDecisionStart());
    return apiService
      .delete(decisionDeletePath(id))
      .then(() => {
        dispatch(deleteDecisionSuccessfully(id));
      })
      .catch((err) => {
        dispatch(deleteDecisionUnsuccessfully(err?.response?.data));
      });
  };
};

export const deleteErrorDecision = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};

export const changeDecisionStatus = (decision, callback) => {
  return (dispatch) => {
    dispatch(changeDecisionStatusStart());
    return apiService
      .post(changeDecisionStatusPath(), decision)
      .then((response) => {
        dispatch(changeDecisionStatusSuccessfully(response.data));
        callback();
      })
      .catch((err) => {
        dispatch(changeDecisionStatusUnsuccessfully(err?.response?.data));
      });
  };
};

export const changeDecisionStatusWithStatus = (
  id,
  status,
  callback,

  messages
) => {
  return (dispatch) => {
    dispatch(changeDecisionStatusWithStatusStart());
    return apiService
      .patch(changeDecisionStatusWithStatusPath(id, status))
      .then((response) => {
        dispatch(changeDecisionStatusWithStatusSuccessfully(response.data));
        callback();
        status === decisionStatuses.SENT.text &&
          createNotification(
            notificationTypeSuccess,
            messages.decisionTitle,
            messages.successSent
          );
        status === decisionStatuses.VERIFIED.text &&
          createNotification(
            notificationTypeSuccess,
            messages.decisionTitle,
            messages.succesVerifiedDecision
          );
        status === decisionStatuses.DELIVERED.text &&
          createNotification(
            notificationTypeSuccess,
            messages.decisionTitle,
            messages.succesDeliveredDecision
          );
        status === decisionStatuses.IN_PREPARATION.text &&
          createNotification(
            notificationTypeSuccess,
            messages.decisionTitle,
            messages.succesInPreparationDecision
          );
      })
      .catch((err) => {
        dispatch(
          changeDecisionStatusWithStatusUnsuccessfully(err?.response?.data)
        );
        createNotification(
          notificationTypeError,
          messages.decisionTitle,
          err?.response?.data
        );
      });
  };
};

export const createDecisionWithAttachment = (
  data,
  reqId,
  callback,
  message
) => {
  return (dispatch) => {
    dispatch(addDecisionStart());
    return apiService
      .post(decisionAddWithAttachmentPath(reqId), data)
      .then((response) => {
        dispatch(addDecisionSuccessfully(response.data));
        callback();
        dispatch(findDecisionAttachmentByDecision(response.data.id));
        createNotification(
          notificationTypeSuccess,
          message.decisionTitle,
          message.successUploadDecision
        );
      })
      .catch((err) => {
        dispatch(addDecisionUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          message.decisionTitle,
          err?.response?.data
        );
      });
  };
};

export const findAllDecisionFilterPageable = (
  pageNumber,
  pageSize,
  data,
  succesCallback
) => {
  return (dispatch) => {
    dispatch(getDecisionFilterListStart());
    return apiService
      .post(filterPageablePath(pageNumber, pageSize), data)
      .then((response) => {
        dispatch(
          getDecisionFilterListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
        succesCallback();
      })
      .catch((err) => {
        dispatch(getDecisionFilterListUnsuccessfully(err?.response?.data));
      });
  };
};

export const sendDecisionToRobon = (id, callback, messages) => {
  return (dispatch) => {
    dispatch(sendDecisionStart());
    return apiService
      .patch(sendDecisionToRobonPath(id))
      .then((response) => {
        dispatch(sendDecisionSuccessfully(response.data));
        callback();
        response.data.decisionStatus === decisionStatuses.DELIVERED.text &&
          createNotification(
            notificationTypeSuccess,
            messages.decisionTitle,
            messages.succesDeliveredDecision
          );
      })
      .catch((err) => {
        dispatch(sendDecisionUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          messages.decisionTitle,
          err?.response?.data.message
        );
      });
  };
};
